import { Button, Link as B2BLink, Stack, Typography } from '@evaneos/b2b-ui';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';

import s from '../../shared/components/layout/ContextualNavbar.module.css';
import { useFiltersDrawer } from '../../shared/providers/FiltersDrawerContext';
import { useTrackEventAmplitude } from '../../shared/analytics';
import { parseQueryString } from '../../shared/utilities/queryString';
import { NavigationToggle } from '../../shared/components/NavigationToggle';
import { useGetInboxCount } from '../../resources/inbox/hooks';
import { useHasDossiers } from '../../resources/dossier-overview/hooks';

export const HomepageNavbar = (): JSX.Element => {
    const location = useLocation();
    const { openFiltersDrawer } = useFiltersDrawer();
    const { trackEvent } = useTrackEventAmplitude();

    const query = parseQueryString(location.search);
    const hasDossiers = useHasDossiers();
    const inboxCount = useGetInboxCount(query);

    const handleFilterButtonClicked = () => {
        openFiltersDrawer();
        trackEvent((ampli, defaultProperties) => {
            ampli.rmFilterClicked({ ...defaultProperties, category: 'inbox' });
        });
    };

    return (
        <nav className={s.navbarContainer}>
            <div className={s.pageSwitch}>
                <NavigationToggle selected="inbox" inboxCount={inboxCount} />
            </div>
            <Stack direction="row" gap={2} alignItems="center">
                <Typography variant="body1">
                    <B2BLink data-testid={'cta-agency-capacity'} href="/agency-manager/capacity">
                        Agency capacity
                    </B2BLink>
                </Typography>

                <Button
                    data-testid="process-navbar-filter-button"
                    disabled={!hasDossiers}
                    variant="outlined"
                    onClick={handleFilterButtonClicked}
                >
                    <FormattedMessage id="processes.filters.filters" />
                </Button>
            </Stack>
        </nav>
    );
};
